// Resource budgets, independent of fixture-type count. The sample budget keeps
// the former worst case (16 files × 20,000 samples) while allowing many smaller
// distributions. The total JSON budget also bounds estimated-only libraries.
export const MAX_IES_BYTES = 512 * 1024;
export const MAX_IES_SAMPLES = 20_000;
export const MAX_LIGHT_PHOTOMETRY_BYTES = 4 * 1024 * 1024;
export const MAX_LIGHT_LIBRARY_BYTES = 8 * 1024 * 1024;
export const MAX_LIGHT_LIBRARY_SAMPLES = 320_000;
export const MAX_LIGHT_LIBRARY_FILE_BYTES = 16 * 1024 * 1024;

const encoder = new TextEncoder();
export const utf8Bytes = text => encoder.encode(text).byteLength;

/** Check storage before parsing angle tables or normalizing/truncating fields.
 * Count UTF-8 bytes, including metadata and JSON escaping, on both client and
 * server. Small definitions consume less budget than large photometric files. */
export function checkLightLibrarySize(definitions) {
  if (!Array.isArray(definitions)) throw new Error('Light definitions must be an array.');
  let bytes = 2, photometryBytes = 0;
  for (const d of definitions) {
    bytes += utf8Bytes(JSON.stringify(d)) + (bytes > 2 ? 1 : 0);
    if (bytes > MAX_LIGHT_LIBRARY_BYTES) throw new Error('Light library data exceeds 8 MB. Import fewer types or remove unused definitions; existing lights are unchanged.');
    if (d?.kind === 'ies') {
      const size = typeof d.sourceText === 'string' ? utf8Bytes(d.sourceText) : 0;
      if (size > MAX_IES_BYTES) throw new Error('Choose an IES file no larger than 512 KB.');
      photometryBytes += size;
      if (photometryBytes > MAX_LIGHT_PHOTOMETRY_BYTES) throw new Error('Light library photometry exceeds 4 MB. Import fewer IES files or remove unused definitions; existing lights are unchanged.');
    }
  }
  return { bytes, photometryBytes };
}
